import { render } from "./AppProfession.vue?vue&type=template&id=7b1c1164"
import script from "./AppProfession.vue?vue&type=script&lang=js"
export * from "./AppProfession.vue?vue&type=script&lang=js"

import "./AppProfession.vue?vue&type=style&index=0&id=7b1c1164&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__